import { apiGet } from './client';

export const DOC_KEY_CALCULATOR_TERMS = 'calculator_terms';

/** Current published document for doc_key (public; no auth required). */
export function getCurrentLegalDocument(docKey) {
  return apiGet(`/api/v1/legal-documents/${encodeURIComponent(docKey)}`);
}

export async function fetchCurrentCalculatorTermsVersion() {
  const doc = await getCurrentLegalDocument(DOC_KEY_CALCULATOR_TERMS);
  return doc?.version || '';
}
